// @flow

import ReactGA from 'react-ga';

import config from '../config/app.config';

import { isAuthorized } from './TagManagerUtils';

export const init = () => {
  ReactGA.initialize(config.analytics.trackingId);
};

export const sendPageView = (path: string) => {
  if (!isAuthorized()) return;

  ReactGA.set({ page: path });
  ReactGA.pageview(path);
};

export default {
  isAuthorized,
  init,
  sendPageView,
};
